import { render, staticRenderFns } from "./OverlayCloseButton.vue?vue&type=template&id=7c3f3a7e&scoped=true&"
import script from "./OverlayCloseButton.vue?vue&type=script&lang=js&"
export * from "./OverlayCloseButton.vue?vue&type=script&lang=js&"
import style0 from "./OverlayCloseButton.vue?vue&type=style&index=0&id=7c3f3a7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3f3a7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
